/**
 * RS / Blog Index — live search across the articles on the page, plus the
 * shared one-shot word reveal (same behavior as RS / Recente Words).
 *
 * Filters the rendered cards by title + excerpt (data-search), updates the
 * running count, shows the clear button and the empty state. Search is a
 * refinement of the current page — tag filtering and pagination stay native
 * and URL-driven.
 */
import { setupWordReveal } from 'rs-recente-words';

class RsBlogIndex extends HTMLElement {
  #revealObserver = null;

  connectedCallback() {
    if (this.dataset.scramble === 'true') {
      this.#revealObserver = setupWordReveal(this);
    }

    this.input = this.querySelector('[data-rs-search-input]');
    this.clearBtn = this.querySelector('[data-rs-search-clear]');
    this.countEl = this.querySelector('[data-rs-search-count]');
    this.emptyEl = this.querySelector('[data-rs-empty]');
    this.cards = Array.from(this.querySelectorAll('[data-rs-article]'));
    if (!this.input || this.cards.length === 0) return;

    this.haystacks = this.cards.map((card) => (card.dataset.search || '').toLowerCase());

    this.input.addEventListener('input', () => this.#filter());
    this.clearBtn?.addEventListener('click', () => {
      this.input.value = '';
      this.#filter();
      this.input.focus();
    });
  }

  disconnectedCallback() {
    this.#revealObserver?.disconnect();
  }

  #filter() {
    const query = this.input.value.trim().toLowerCase();
    let visible = 0;

    for (let i = 0; i < this.cards.length; i++) {
      const match = query === '' || this.haystacks[i].includes(query);
      this.cards[i].hidden = !match;
      if (match) visible += 1;
    }

    if (this.clearBtn) this.clearBtn.hidden = query === '';
    if (this.emptyEl) this.emptyEl.hidden = visible > 0;
    if (this.countEl) {
      const word = visible === 1 ? this.countEl.dataset.singular : this.countEl.dataset.plural;
      this.countEl.textContent = `${visible} ${word}`;
    }
  }
}

if (!customElements.get('rs-blog-index')) {
  customElements.define('rs-blog-index', RsBlogIndex);
}
